<form (submit)="saveAndNext()" [formGroup]="form" (keydown.enter)="saveAndNext()" class="main-form">
  <div class="card mb-4">
    <div class="card-header"><fa-icon [icon]="faTicket"></fa-icon> Détails du vol</div>
    <div class="card-body">
      <div
        class="form-check form-switch d-flex justify-content-center align-items-center gap-2"
        >
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          id="isFerryFlight"
          formControlName="isFerryFlight"
          />
        <label class="form-check-label" for="isFerryFlight">Vol de positionnement</label>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="flightNumber">Numéro de vol</label>
            <input
              type="text"
              id="flightNumber"
              formControlName="flightNumber"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || flightNumber.touched) &&
                                flightNumber.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || flightNumber.touched) &&
                flightNumber.errors &&
                flightNumber.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="callsign">{{ "ENQUIRY_FLIGHTS.CALLSIGN" | translate }}</label>
            <input
              type="text"
              id="callsign"
              formControlName="callsign"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || callsign.touched) && callsign.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || callsign.touched) &&
                callsign.errors &&
                callsign.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="otherComment"
              [innerText]="'FLIGHT_BRIEF.AIRPORT_INFORMATION.OTHER' | translate"
            ></label>
            <input
              type="text"
              id="otherComment"
              formControlName="otherComment"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || otherComment.touched) &&
                                otherComment.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || otherComment.touched) &&
                otherComment.errors &&
                otherComment.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="checkInScreenMessage"
                            [innerText]="
                                'FLIGHT_BRIEF.AIRPORT_INFORMATION.CHECK_IN_SCREEN_MESSAGE'
                                    | translate
                            "
            ></label>
            <input
              type="text"
              id="checkInScreenMessage"
              formControlName="checkInScreenMessage"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || checkInScreenMessage.touched) &&
                                checkInScreenMessage.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || checkInScreenMessage.touched) &&
                checkInScreenMessage.errors &&
                checkInScreenMessage.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="seatingPlan"
                            [innerText]="
                                'FLIGHT_BRIEF.AIRPORT_INFORMATION.SEATING_PLAN' | translate
                            "
            ></label>
            <select
              id="seatingPlanType"
              formControlName="seatingPlanType"
              class="form-select"
                            [class.is-invalid]="
                                (form.touched || seatingPlanType.touched) &&
                                seatingPlanType.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              >
              <option
                [ngValue]="null"
                [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
              ></option>
              @for (item of getSeatingPlans(); track item) {
                <option
                  [value]="item"
                  [innerText]="getEnquiryFlightSeatingPlanLabel(item) | translate"
                ></option>
              }
            </select>
            @if (seatingPlanType.value === EnumEnquiryFlightSeatingPlan.other) {
              <input
                type="text"
                id="seatingPlan"
                formControlName="seatingPlan"
                class="form-control"
                            [class.is-invalid]="
                                (form.touched || seatingPlan.touched) &&
                                seatingPlan.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                />
            }
            <div class="invalid-tooltip">
              @if (
                (form.touched || seatingPlan.touched) &&
                seatingPlan.errors &&
                seatingPlan.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="boardingPass"
                            [innerText]="
                                'FLIGHT_BRIEF.AIRPORT_INFORMATION.BOARDING_PASS' | translate
                            "
            ></label>
            <select
              id="boardingPassType"
              formControlName="boardingPassType"
              class="form-select"
                            [class.is-invalid]="
                                (form.touched || boardingPassType.touched) &&
                                boardingPassType.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              >
              <option
                [ngValue]="null"
                [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
              ></option>
              @for (item of getBoardingPasses(); track item) {
                <option
                  [value]="item"
                  [innerText]="getEnquiryFlightBoardingPassLabel(item) | translate"
                ></option>
              }
            </select>
            @if (boardingPassType.value === EnumEnquiryFlightBoardingPass.other) {
              <input
                type="text"
                id="boardingPass"
                formControlName="boardingPass"
                class="form-control"
                            [class.is-invalid]="
                                (form.touched || boardingPass.touched) &&
                                boardingPass.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                />
            }
            <div class="invalid-tooltip">
              @if (
                (form.touched || boardingPass.touched) &&
                boardingPass.errors &&
                boardingPass.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="passengersNationality"
                            [innerText]="
                                'FLIGHT_BRIEF.AIRPORT_INFORMATION.PASSENGERS_NATIONALITY'
                                    | translate
                            "
            ></label>
            <input
              type="text"
              id="passengersNationality"
              formControlName="passengersNationality"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || passengersNationality.touched) &&
                                passengersNationality.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || passengersNationality.touched) &&
                passengersNationality.errors &&
                passengersNationality.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="kindOfPassengers"
                            [innerText]="
                                'FLIGHT_BRIEF.AIRPORT_INFORMATION.KIND_OF_PASSENGERS' | translate
                            "
            ></label>
            <input
              type="text"
              id="kindOfPassengers"
              formControlName="kindOfPassengers"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || kindOfPassengers.touched) &&
                                kindOfPassengers.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || kindOfPassengers.touched) &&
                kindOfPassengers.errors &&
                kindOfPassengers.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="targetOfTheTrip"
                            [innerText]="
                                'FLIGHT_BRIEF.AIRPORT_INFORMATION.TARGET_OF_THE_TRIP' | translate
                            "
            ></label>
            <input
              type="text"
              id="targetOfTheTrip"
              formControlName="targetOfTheTrip"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || targetOfTheTrip.touched) &&
                                targetOfTheTrip.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              (keyup)="updateOnBoardFlightAnnouncement(true)"
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || targetOfTheTrip.touched) &&
                targetOfTheTrip.errors &&
                targetOfTheTrip.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="onboardOther"
              [innerText]="'FLIGHT_BRIEF.ONBOARD_INFORMATION.OTHER' | translate"
            ></label>
            <input
              type="text"
              id="onboardOther"
              formControlName="onboardOther"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || onboardOther.touched) &&
                                onboardOther.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || onboardOther.touched) &&
                onboardOther.errors &&
                onboardOther.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="mandatoryCNI"
              formControlName="mandatoryCNI"
              />
            <label
              for="mandatoryCNI"
              class="form-check-label"
                            [innerText]="
                                'FLIGHT_BRIEF.AIRPORT_INFORMATION.IS_CNI_MANDATORY' | translate
                            "
            ></label>
          </div>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="mandatoryPassport"
              formControlName="mandatoryPassport"
              />
            <label
              for="mandatoryPassport"
              class="form-check-label"
                            [innerText]="
                                'FLIGHT_BRIEF.AIRPORT_INFORMATION.IS_PASSPORT_MANDATORY' | translate
                            "
            ></label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="counterCount"
                            [innerText]="
                                'FLIGHT_BRIEF.ONBOARD_INFORMATION.NUMBER_OF_COUNTERS' | translate
                            "
            ></label>
            <input
              type="text"
              id="counterCount"
              formControlName="counterCount"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || counterCount.touched) &&
                                counterCount.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || counterCount.touched) &&
                counterCount.errors &&
                counterCount.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="countersPerHour"
                            [innerText]="
                                'FLIGHT_BRIEF.ONBOARD_INFORMATION.COUNTERS_PER_HOUR' | translate
                            "
            ></label>
            <input
              type="text"
              id="countersPerHour"
              formControlName="countersPerHour"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || countersPerHour.touched) &&
                                countersPerHour.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || countersPerHour.touched) &&
                countersPerHour.errors &&
                countersPerHour.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label
              for="headrestCovers"
                            [innerText]="
                                'FLIGHT_BRIEF.ONBOARD_INFORMATION.HEADREST_COVERS' | translate
                            "
            ></label>
            <input
              type="text"
              id="headrestCovers"
              formControlName="headrestCovers"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || headrestCovers.touched) &&
                                headrestCovers.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || headrestCovers.touched) &&
                headrestCovers.errors &&
                headrestCovers.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label
              for="departTransferGATBoardingPass"
                            [innerText]="
                                ('FLIGHT_BRIEF.DEPARTURE' | translate) + ' - ' +
                                ('FLIGHT_BRIEF.ONBOARD_INFORMATION.TRANSFER_GAT_BOARDING_PASS'
                                    | translate)
                            "
            ></label>
            <input
              type="text"
              id="departTransferGATBoardingPass"
              formControlName="departTransferGATBoardingPass"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || departTransferGATBoardingPass.touched) &&
                                departTransferGATBoardingPass.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || departTransferGATBoardingPass.touched) &&
                departTransferGATBoardingPass.errors &&
                departTransferGATBoardingPass.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="arrivalTransferGATBoardingPass"
                            [innerText]="
                                ('FLIGHT_BRIEF.ARRIVAL' | translate) + ' - ' +
                                ('FLIGHT_BRIEF.ONBOARD_INFORMATION.TRANSFER_GAT_BOARDING_PASS'
                                    | translate)
                            "
            ></label>
            <input
              type="text"
              id="arrivalTransferGATBoardingPass"
              formControlName="arrivalTransferGATBoardingPass"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || arrivalTransferGATBoardingPass.touched) &&
                                arrivalTransferGATBoardingPass.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || arrivalTransferGATBoardingPass.touched) &&
                arrivalTransferGATBoardingPass.errors &&
                arrivalTransferGATBoardingPass.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="departTourLeader"
                            [innerText]="
                                ('FLIGHT_BRIEF.DEPARTURE' | translate) + ' - ' +
                                ('FLIGHT_BRIEF.ONBOARD_INFORMATION.TOUR_LEADER' | translate)
                            "
            ></label>
            <input
              type="text"
              id="departTourLeader"
              formControlName="departTourLeader"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || departTourLeader.touched) &&
                                departTourLeader.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || departTourLeader.touched) &&
                departTourLeader.errors &&
                departTourLeader.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="departTourLeaderPhone">
              {{ 'FLIGHT_BRIEF.DEPARTURE' | translate }} -
              {{ 'FLIGHT_BRIEF.ONBOARD_INFORMATION.TOUR_LEADER_PHONE' | translate }}
            </label>
            <input
              type="tel"
              id="departTourLeaderPhone"
              formControlName="departTourLeaderPhone"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="arrivalTourLeader"
                            [innerText]="
                                ('FLIGHT_BRIEF.ARRIVAL' | translate) + ' - ' +
                                ('FLIGHT_BRIEF.ONBOARD_INFORMATION.TOUR_LEADER' | translate)
                            "
            ></label>
            <input
              type="text"
              id="arrivalTourLeader"
              formControlName="arrivalTourLeader"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || arrivalTourLeader.touched) &&
                                arrivalTourLeader.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || arrivalTourLeader.touched) &&
                arrivalTourLeader.errors &&
                arrivalTourLeader.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="arrivalTourLeaderPhone">
              {{ 'FLIGHT_BRIEF.ARRIVAL' | translate }} -
              {{ 'FLIGHT_BRIEF.ONBOARD_INFORMATION.TOUR_LEADER_PHONE' | translate }}
            </label>
            <input
              type="tel"
              id="arrivalTourLeaderPhone"
              formControlName="arrivalTourLeaderPhone"
              class="form-control"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label
              for="vipSeatingFront"
                            [innerText]="
                                'FLIGHT_BRIEF.ONBOARD_INFORMATION.VIP_SEATING_FRONT' | translate
                            "
            ></label>
            <input
              type="text"
              id="vipSeatingFront"
              formControlName="vipSeatingFront"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || vipSeatingFront.touched) &&
                                vipSeatingFront.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || vipSeatingFront.touched) &&
                vipSeatingFront.errors &&
                vipSeatingFront.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label
              for="departReducedMobilityPassengers"
                            [innerText]="
                                ('FLIGHT_BRIEF.DEPARTURE' | translate) + ' - ' +
                                ('FLIGHT_BRIEF.ONBOARD_INFORMATION.REDUCED_MOBILITY_PASSENGERS'
                                    | translate)
                            "
            ></label>
            <input
              type="text"
              id="departReducedMobilityPassengers"
              formControlName="departReducedMobilityPassengers"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || departReducedMobilityPassengers.touched) &&
                                departReducedMobilityPassengers.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || departReducedMobilityPassengers.touched) &&
                departReducedMobilityPassengers.errors &&
                departReducedMobilityPassengers.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="arrivalReducedMobilityPassengers"
                            [innerText]="
                                ('FLIGHT_BRIEF.ARRIVAL' | translate) + ' - ' +
                                ('FLIGHT_BRIEF.ONBOARD_INFORMATION.REDUCED_MOBILITY_PASSENGERS'
                                    | translate)
                            "
            ></label>
            <input
              type="text"
              id="arrivalReducedMobilityPassengers"
              formControlName="arrivalReducedMobilityPassengers"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || arrivalReducedMobilityPassengers.touched) &&
                                arrivalReducedMobilityPassengers.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || arrivalReducedMobilityPassengers.touched) &&
                arrivalReducedMobilityPassengers.errors &&
                arrivalReducedMobilityPassengers.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label
              for="oversizeBaggage"
                            [innerText]="
                                'FLIGHT_BRIEF.ONBOARD_INFORMATION.OVERSIZE_BAGGAGE' | translate
                            "
            ></label>
            <input
              type="text"
              id="oversizeBaggage"
              formControlName="oversizeBaggage"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || oversizeBaggage.touched) &&
                                oversizeBaggage.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || oversizeBaggage.touched) &&
                oversizeBaggage.errors &&
                oversizeBaggage.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label
              for="specialRemarks"
                            [innerText]="
                                'FLIGHT_BRIEF.ONBOARD_INFORMATION.SPECIAL_REMARK' | translate
                            "
            ></label>
            <input
              type="text"
              id="specialRemarks"
              formControlName="specialRemarks"
              class="form-control"
                            [class.is-invalid]="
                                (form.touched || specialRemarks.touched) &&
                                specialRemarks.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />
            <div class="invalid-tooltip">
              @if (
                (form.touched || specialRemarks.touched) &&
                specialRemarks.errors &&
                specialRemarks.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
      </div>
      <fieldset formGroupName="onBoardFlightAnnouncement">
        <legend
                    [innerText]="
                        'FLIGHT_BRIEF.ONBOARD_INFORMATION.ON_BOARD_FLIGHT_ANNOUNCEMENT' | translate
                    "
        ></legend>
        @for (language of languages; track language) {
          <div class="form-group">
            <label
              [attr.for]="'onBoardFlightAnnouncement-' + language"
              [innerText]="getLanguageLabel(language) | translate"
            ></label>
            <textarea
              [id]="'onBoardFlightAnnouncement-' + language"
              [formControlName]="language"
              class="form-control"
                        [class.is-invalid]="
                            (form.touched ||
                                getOnBoardFlightAnnouncementByLanguage(language).touched) &&
                            getOnBoardFlightAnnouncementByLanguage(language).status === 'INVALID'
                                ? 'danger'
                                : ''
                        "
              rows="3"
            ></textarea>
            <div class="invalid-tooltip">
              @if (
                (form.touched ||
                getOnBoardFlightAnnouncementByLanguage(language).touched) &&
                getOnBoardFlightAnnouncementByLanguage(language).errors &&
                getOnBoardFlightAnnouncementByLanguage(language).errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        }
      </fieldset>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col">
      <button
        type="button"
        class="btn btn-secondary"
        [disabled]="form.disabled"
        (click)="prev()"
        >
        <fa-icon [icon]="faArrowLeft"></fa-icon>
        {{ "GENERAL.PREVIOUS" | translate }}
      </button>
    </div>
    <div class="col text-end">
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="form.disabled || !form.valid"
        (click)="saveAndNext()"
        >
        {{ "GENERAL.NEXT" | translate }}
        <fa-icon [icon]="faArrowRight"></fa-icon>
      </button>
    </div>
  </div>
</form>
